import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";
import { components } from "react-select";
import { OptionProps } from "react-select/src/components/Option";

import { SELECT_CLASS_NAME } from "../types";

export const Option: FunctionComponent<OptionProps<any>> = memo(
  props => {
    const size = props.selectProps.size;
    const classes = classNames(props.className, {
      [`${SELECT_CLASS_NAME}__option--size-${size}`]: size,
    });
    return <components.Option {...props} className={classes} />;
  },
  /*
    This is needed to make Select more performant

    1. If you remove this and move the mouse up and down
       you will see Select is a bit laggy
    2. We can't remove onMouseMove and onMouseOver events
       because user will not be able yo use keyboard with Select
    3. Things that can be done to speed up Select if needed
       https://github.com/JedWatson/react-select/issues/3128
  */
  (prevProps, nextProps) => {
    return prevProps.isFocused === nextProps.isFocused;
  },
);
